import { z } from "zod";
import { NullishDateTimeWithOffset } from "@/lib/api/schemas/patterns";

export const CycleMessageLevel = z.enum(["debug", "info", "warning", "error"]);
export type CycleMessageLevel = z.infer<typeof CycleMessageLevel>;

const CycleMessageType = z.enum(["message", "file"]);
const unknownRecord = z.record(z.string(), z.unknown());
const CycleMessageRawData = z
  .object({
    payload: z.union([unknownRecord, z.string()]).nullish(),
  })
  .passthrough();

export const CycleMessageItem = z.object({
  type: CycleMessageType.nullish(),
  id: z.number().nullish(),
  created_at: NullishDateTimeWithOffset,
  timestamp: NullishDateTimeWithOffset,
  time_since_scheduled_start: z.number().nullish(),
  level: CycleMessageLevel.nullish().transform((value) => value ?? "info"),
  message_type: z.string().nullish(),
  data: z.union([unknownRecord, z.string()]).nullish(),
  category: z.string().nullish(),
  file_size: z.number().int().nullish(),
  url: z.string().nullish(),
  extra_data: unknownRecord.nullish(),
  raw_data: CycleMessageRawData.nullish(),
  turn: z.string().nullish(),
});
export type CycleMessageItem = z.infer<typeof CycleMessageItem>;
